import moment from "moment";

export const convertToHumanDate = (date) =>
  moment.unix(+new Date(date) / 1000).format("YYYY-MM-DD");

export const converToOrderDate = (date) =>
  moment.utc(moment.unix(+new Date(date) / 1000)).format("YYYY-MM-DDTHH:mm");

export const convertToHumanOrderDate = (date) =>
  moment
    .unix(+new Date(date) / 1000)
    .local()
    .format("YYYY-MM-DD HH:mm");

export const getReportFileName = () =>
  moment
    .unix(+new Date() / 1000)
    .local()
    .format("YYYY-MM-DD HH:mm");

export const convertToHumanDateTime = (date, format = "DD-MMM-YYYY HH:mm") =>
  moment
    .unix(+new Date(date) / 1000)
    .local()
    .format(format);

export const checkMinutesPassed = (dateString, minutes) => {
  const inputDate = new Date(dateString);
  const currentTime = new Date();
  const timeDiff = currentTime - inputDate;
  const minutesPassed = Math.floor(timeDiff / (1000 * 60));
  return minutesPassed >= minutes;
};

export const convertToTimestamp = () => {
  const now = new Date();
  const timestamp = Math.floor(now.getTime() / 1000);
  return timestamp;
};
